import Vue from 'vue';

Vue.filter('date', value => {
  if (!value) return '';

  const date = new Date(value * 1000);
  const formatedDate = `${date.getDate()}.${date
    .toLocaleString('pt-br', { month: 'short' })
    .toUpperCase()}`;
  return formatedDate;
});

Vue.filter('currency', value => {
  if (value === 0) return `R$ 0,00`;
  if (!value) return '';
  return `R$ ${(value / 100).toFixed(2)}`.replace('.', ',');
});

Vue.filter('simpleCurrency', value => {
  if (!value) return 'R$ 0';
  return `R$ ${value.toFixed(2)}`.replace('.', ',');
});

Vue.filter('rawCurrency', value => {
  if (!value) return '';
  return `${(value / 100).toFixed(2)}`.replace('.', ',');
});

Vue.filter('cardFlag', cardNumber => {
  const visa = /^4[0-9]{12}(?:[0-9]{3})?$/;
  const master = /^(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$/;
  const amex = /^3[47][0-9]{13}$/;
  const dinners = /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/;
  const discover = /^6(?:011|5[0-9]{2})[0-9]{12}$/;
  const jcb = /^(?:2131|1800|35\d{3})\d{11}$/;
  const elo = /^((((636368)|(438935)|(504175)|(451416)|(636297))\d{0,10})|((5067)|(4576)|(4011))\d{0,12})$/;
  const hipercard = /^(606282\d{10}(\d{3})?)|(3841\d{15})$/;
  const maestro = /^(?:5[0678]\d\d|6304|6390|67\d\d)\d{8,15}$/;

  if (visa.test(cardNumber)) {
    return 'Visa';
  }
  if (master.test(cardNumber)) {
    return 'Master';
  }
  if (amex.test(cardNumber)) {
    return 'Amex';
  }
  if (dinners.test(cardNumber)) {
    return 'Dinners Club';
  }
  if (discover.test(cardNumber)) {
    return 'Discover';
  }
  if (jcb.test(cardNumber)) {
    return 'JCB';
  }
  if (elo.test(cardNumber)) {
    return 'Elo';
  }
  if (hipercard.test(cardNumber)) {
    return 'Hipercard';
  }
  if (maestro.test(cardNumber)) {
    return 'Maestro';
  }
});

Vue.filter('two_digits', value => {
  if (value < 0) {
    return '00';
  }
  if (value.toString().length <= 1) {
    return `0${value}`;
  }
  return value;
});
